import { render, staticRenderFns } from "./PlanExpired.vue?vue&type=template&id=c219f5e0&"
import script from "./PlanExpired.vue?vue&type=script&lang=js&"
export * from "./PlanExpired.vue?vue&type=script&lang=js&"
import style0 from "./PlanExpired.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports